import includes from 'lodash.includes';
import { Env } from '@functions/index';
import settings from '@assets/settings';

const isLocalhost = () => includes(window.location.hostname, 'localhost');
const isProduction = () => !isLocalhost();

const isAdmin = includes(window.location.pathname, 'admin');

const apiUrl = () => (Env.isLocalhost() ? 'http://localhost:8080' : 'https://api-unity-n6ohk.ondigitalocean.app');

const isHomePage = () => window.location.pathname === '/' || window.location.pathname === '/test' || window.location.pathname === '/test/';

const apiHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': settings.apiKey,
    authorization: `Bearer ${JSON.parse((localStorage.getItem('user-session-rs') as string | undefined) || '{}').token}`,
  },
});

export default {
  isProduction,
  isLocalhost,
  isAdmin,
  isHomePage,
  apiUrl,
  apiHeaders,
};
